import 'config/environment';
import 'core-js/features/object/from-entries';
import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import '@formatjs/intl-relativetimeformat/locale-data/en';
import { getEnvironment } from '@minecraft.environment';
import { RouteProvider, createHistory } from '@blocs.router';
import { initObservability } from '@blocs.observability';
import App from './App';

const environment = getEnvironment();
const history = createHistory();

initObservability({ history });

TagManager.initialize({
  gtmId: environment.GOOGLE_TAG_MANAGER_ID,
  auth: environment.GOOGLE_TAG_MANAGER_ENVIRONMENT_AUTH,
  preview: environment.GOOGLE_TAG_MANAGER_ENVIRONMENT_PREVIEW,
});

ReactDOM.render(
  <RouteProvider history={history}>
    <App />
  </RouteProvider>,
  document.getElementById('app')
);
